<template>
  <sidebar
    :data="data"
    :logo-src="logo"
    :logo-icon-src="logoIcon"
    :user="newUser"
    :profile-data="profileData"
    :role="role"
  />
</template>

<script>
import { UserMixin } from "../Auth/Mixins/UserMixin";
import * as actions from "../../../Config/ApiUrl";
import { axiosPost } from "../../../Helpers/AxiosHelper";
import { mapActions } from "vuex";
import AppFunction from "../../../../core/helpers/app/AppFunction";
export default {
  name: "DashboardSidebar",
  mixins: [UserMixin],
  props: {
    logo: {
      type: String,
      default: AppFunction.getAppUrl("images/icon.png"),
    },
    data: {
      required: true,
    },

    logoIcon: {
      type: String,
    },
    role: {
      type: Array,
    },
  },
  data() {
    return {
      newUser:{},
      current_role: "",
      data2 : [],
      profileData: [
        {
          optionName: "My Profile",
          optionIcon: "user",
          url: actions.MY_PROFILE,
        },
        {
          optionName: "Notifications",
          optionIcon: "bell",
          url: actions.All_NOTIFICATION,
        },
        // {
        //   optionName: "Settings",
        //   optionIcon: "settings",
        //   url: actions.APP_SETTINGS,
        // },
        {
          optionName: "Logout",
          optionIcon: "log-out",
          url: actions.LOGOUT,
        },
      ],
    };
  },
  mounted() {
    this.datafilter();
    this.setUser()
  },

  methods: {
    setUser(){
      this.newUser = this.$store.state.user.loggedInUser;
    }
    ,
    datafilter() {
      // console.log(this.role[0][0]);
      //   if (this.role == "App Admin") {
      //     const index = this.data[2].name;
      //     if (index == "Customer Invoice") {
      //       this.data.splice(2, 1);
      //     }
      //     return this.data;
      //   }
      if (this.role[0][0] == "App Admin") {
        let d = this.data.filter((e, i) => {
          let a = e.name !== "Customer Invoice" && e.name !== "My Invoices" && e.name !== "Certificates";
          return a;
        });
        this.data2 = d;
      } else {
        return this.data2;
      }
    },
  },
};
</script>
